export default class Auth {
  static getRequestAuth () {
    return {
      headers: {
        'Authorization': `Bearer ${this.getToken ()}`
      }
    }
  }

  static signIn (data) {
    localStorage.setItem ('token', data.token)
    if (data.business)
      localStorage.setItem ('business', JSON.stringify (data.business))
    else if (data.company)
      localStorage.setItem ('company', JSON.stringify (data.company))
    else if (data.professional)
      localStorage.setItem ('professional', JSON.stringify (data.professional))
    else if (data.member)
      localStorage.setItem ('member', JSON.stringify (data.member))
    else if (data.admin)
      localStorage.setItem ('admin', JSON.stringify (data.admin))
  }

  static businessSignOut () {
    if (!this.isAdmin () && !this.isCompany ()) localStorage.removeItem ('token')
    localStorage.removeItem ('business')
    localStorage.removeItem ('professional')
  }

  static companySignOut () {
    localStorage.removeItem ('token')
    localStorage.removeItem ('company')
  }

  static adminSignOut () {
    localStorage.removeItem ('token')
    localStorage.removeItem ('admin')
  }
  
  static memberSignOut () {
    localStorage.removeItem ('token')
    localStorage.removeItem ('member')
  }

  static getToken () {
    return localStorage.getItem ('token')
  }

  static isSigned () {
    return this.getToken () !== null
  }

  static isAdmin () {
    return localStorage.getItem ('admin') !== null
  }

  static isCompany () {
    return localStorage.getItem ('company') !== null
  }

  static isBusiness () {
    return localStorage.getItem ('business') !== null
  }

  static isProfessional () {
    return localStorage.getItem ('professional') !== null
  }

  static isMember () {
    return localStorage.getItem ('member') !== null
  }

  static getBusinessId () {
    const user = this.getUser ()
    return this.isBusiness () ? user.id : user.business_id
  }

  static getUserType () {
    if (this.isAdmin ()) return 'admin'
    if (this.isMember ()) return 'member'
    if (this.isBusiness ()) return 'business'
    if (this.isCompany ()) return 'company'
    if (this.isProfessional ()) return 'professional'
    return null
  }

  static getUser () {
    if (this.isBusiness ())
      return JSON.parse (localStorage.getItem ('business'))
    if (this.isCompany ())
      return JSON.parse (localStorage.getItem ('company'))
    if (this.isProfessional ())
      return JSON.parse (localStorage.getItem ('professional'))
      if (this.isMember ())
        return JSON.parse (localStorage.getItem ('member'))
    if (this.isAdmin ())
      return JSON.parse (localStorage.getItem ('admin'))
  }

  static accessBusiness (businessData) {
    const userType = this.getUserType ()
    if (!['admin', 'company'].includes (userType)) return

    localStorage.setItem ('business', JSON.stringify (businessData))
  }

  static updateUser (data) {
    if (data.business)
      localStorage.setItem ('business', JSON.stringify (data.business))
    else if (data.company)
      localStorage.setItem ('company', JSON.stringify (data.company))
    else if (data.professional)
      localStorage.setItem ('professional', JSON.stringify (data.professional))
    else if (data.member)
      localStorage.setItem ('member', JSON.stringify (data.member))
    window.dispatchEvent (new CustomEvent ('userUpdated'))
  }

  static hasPermission (areaCode, permissionType = 'view') {
    const user = this.getUser ()
    const userType = this.getUserType ()

    if (['admin', 'business', 'company'].includes (userType)) return true
    if (!user || !Array.isArray (user.permissions)) return false

    const { permissions } = user
    const permission = permissions?.find (p => p.area_code === areaCode)

    if (permission) {
      if (permissionType === 'edit' && permission.allow_edit) return true
      if (permissionType === 'delete' && permission.allow_delete) return true
      if (permissionType === 'view') return true
    }

    return false
  }
}
